import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useState } from "react"
import { UPDATE_BOOKING } from "../../GraphQL/Mutations/bookings";
import { GET_BOOKING_BY_SOURCE_ID } from "../../GraphQL/Queries/bookings";
import moment from "moment";
import { Trans } from "react-i18next";
import { reverseReceiveTime, validateInputDates } from '../../Helpers/ReceiveTimeInArray';

const EUEditBookingActionButton = ({ legacyApiEditBooking, settings, gqlBooking }) => {
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    // const [updateBookingMutation, {}] = useMutation(UPDATE_BOOKING);

    const parseBookingFormInput = (bookingForm, tempLocaleTime) => {
        const { start_date, end_date, pick_up_time, drop_off_time, vehicle_usage, notes } = bookingForm;
        const { id: bookingId, vehicleId } = gqlBooking;

        const getIsoFromDateTime = (date, time) => moment(`${date} ${reverseReceiveTime(time)}`).format('YYYY-MM-DDTHH:mm:ssZ');

        const {
            scheduledReleasedAt,
            releaseTime,
            releaseDate,
            scheduledReturnedAt,
            returnTime,
            returnDate,
        } = tempLocaleTime

        return {
            id: +bookingId,
            vehicleId,
            scheduledReleasedAt: releaseTime && releaseDate ? scheduledReleasedAt : getIsoFromDateTime(releaseDate ?? start_date, releaseTime ?? pick_up_time),
            scheduledReturnedAt: returnTime && returnDate ? scheduledReturnedAt : getIsoFromDateTime(returnDate ?? end_date, returnTime ?? drop_off_time),
            usageType: settings.vehicle_usage_types[vehicle_usage],
            specialRequestRemark: notes,
        }
    }

    // [not in use due to queue data sync implementation]
    const updateBookingGraphQL = async (bookingForm, tempLocaleTime, editBookingSuccessActions) => {
        // const bookingInput = parseBookingFormInput(bookingForm, tempLocaleTime, gqlBooking);
        // const parsedBookingInput = validateInputDates(bookingInput, gqlBooking);
        // try {
        //     await updateBookingMutation({ variables: { input: parsedBookingInput } })
        //     editBookingSuccessActions();
        // } catch (error) {
        //     console.error('[updateBookingMutation] error: ', error);
        // } finally {
        //     setLoadingUpdate(false);
        // }
    }

    const updateBooking = () => {
        // setLoadingUpdate(true);
        legacyApiEditBooking(updateBookingGraphQL, setLoadingUpdate);
    };

    return (
        <button className="button primary ml-16" onClick={updateBooking} disabled={loadingUpdate} >
            <Trans>Submit</Trans>
        </button>
    )
}

export default EUEditBookingActionButton